
// services/googleMapsLoader.ts
// This global declaration is necessary to add a property to the window object.
declare global {
    interface Window {
        google: any;
        gm_authFailure?: () => void;
        __intelOpticsMapsReady?: () => void;
    }
}

let googleMapsPromise: Promise<void> | null = null;

export const AUTH_ERROR_EVENT = 'google-maps-auth-error';

export const loadGoogleMaps = (apiKeyArg?: string): Promise<void> => {
    if (googleMapsPromise) {
        return googleMapsPromise;
    }
    
    // Prioritize argument, then Vite env var

    const apiKey = apiKeyArg || import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '';

    // v=beta required for PlaceAutocompleteElement (new Places API replacing deprecated Autocomplete)
    // Note: 'visualization' library removed — HeatmapLayer was deprecated in Maps JS API v3.65
    const GOOGLE_MAPS_API_URL = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=marker,places&loading=async&v=beta&callback=__intelOpticsMapsReady`;

    googleMapsPromise = new Promise((resolve, reject) => {
        // Avoid loading script if it's already there (e.g., from a previous session)
        if (window.google && window.google.maps) {
            return resolve();
        }

        const script = document.createElement('script');
        script.src = GOOGLE_MAPS_API_URL;
        script.async = true;
        script.defer = true;
        
        // The Google Maps script will call this global function upon error.
        window.gm_authFailure = () => {
            googleMapsPromise = null;
            reject(new Error('Google Maps authorization failed.'));
            document.dispatchEvent(new CustomEvent(AUTH_ERROR_EVENT));
        };

        window.__intelOpticsMapsReady = () => {
            delete window.__intelOpticsMapsReady;
            resolve();
        };

        script.onerror = () => {
            googleMapsPromise = null;
            reject(new Error('Google Maps script could not be loaded.'));
        };

        document.head.appendChild(script);
    });

    return googleMapsPromise;
};
